jQuery(document).ready(function ($) {
  // Hamburger Animation
  $(".hamburger").click(function () {
    $(".hamburger").toggleClass("is-active");
    $(".menu-wrap").toggleClass("is-open");
  });

  $(document).ready(function () {
    var heroHeight = $(".hero-banner-wrap").innerHeight();
    var smHeight = $(".scroll-nav-wrap").innerHeight();
    $(window).scroll(function () {
      if ($(window).scrollTop() > heroHeight) {
        $(".scroll-nav-wrap").addClass("fix-me");
        $("body").css("padding-top", smHeight);
      } else {
        $(".scroll-nav-wrap").removeClass("fix-me");
        $("body").css("padding-top", "0");
      }
    });

    $(".divisions-item").click(function () {
      $(".divisions-item").removeClass("openPanel");
      $(this).addClass("openPanel");
    });
  });

  //   (function () {
  //     "use strict";

  //     var section = document.querySelectorAll(".ss-slide");
  //     var sections = {};
  //     var i = 0;

  //     Array.prototype.forEach.call(section, function (e) {
  //       sections[e.id] = e.offsetTop;
  //     });

  //     window.onscroll = function () {
  //       var scrollPosition =
  //         document.documentElement.scrollTop || document.body.scrollTop;

  //       for (i in sections) {
  //         if (sections[i] <= scrollPosition) {
  //           document.querySelector(".active").setAttribute("class", " ");
  //           document
  //             .querySelector("a[href*=" + i + "]")
  //             .setAttribute("class", "active");
  //         }
  //       }
  //     };
  //   })();

  // Bootstrap modal backdrop fix
  $(document).on("show.bs.modal", ".modal", function () {
    $(this).appendTo("body");
  });

  //Aos Init
  AOS.init();
});
